import FAQSection from "../components/FAQSection";
import { usePortal } from "../lib/portal";

export default function FAQPage() {
  const { data } = usePortal();
  return (
    <div className="pt-[110px]">
      <FAQSection faqs={data!.faqs} />
    </div>
  );
}
